import { render, staticRenderFns } from "./DisableServiceDialog.vue?vue&type=template&id=36c123ca"
import script from "./DisableServiceDialog.vue?vue&type=script&lang=js"
export * from "./DisableServiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c123ca')) {
      api.createRecord('36c123ca', component.options)
    } else {
      api.reload('36c123ca', component.options)
    }
    module.hot.accept("./DisableServiceDialog.vue?vue&type=template&id=36c123ca", function () {
      api.rerender('36c123ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BrandSettings/DisableServiceDialog.vue"
export default component.exports